
import { Component, Vue, Prop } from 'vue-property-decorator';
import { iConsumeRecord } from '../../../interface/consume-record';
import { eConfigId, eBillingMethod } from '../../../interface/eCommand';
import moment from 'moment';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
  },
})
export default class extends Vue {
  private experience: eConfigId = eConfigId.EXPERIENCE;
  private configArr = ['全部状态', '标配服', '高配服', '体验服', '尊享服'];
  private cloudcion = eBillingMethod.CLOUDCION;
  private experienceTwo = eBillingMethod.EXPERIENCE;
  private cyclecard = eBillingMethod.CYCLECARD;
  @Prop({ type: Object, required: true }) info!: iConsumeRecord;
}
